(function() {
	const handleScroll = () => {
		const header = document.getElementById('navbar');
		const headerBlack = document.getElementById('navbar-black');
		const scrolled = window.pageYOffset || document.documentElement.scrollTop;

		if (document.getElementById('catalog-page')) {
			const filters = document.getElementById('catalog-filters');
			const catalogPage = document.getElementById('catalog-page');

			headerBlack.classList.add('--catalog');
			if (scrolled >= 42) {
				filters.classList.add('--fixed');
				catalogPage.classList.add('--fixed');
			} else {
				filters.classList.remove('--fixed');
				catalogPage.classList.remove('--fixed');
			}

			return false;
		}

		if (header) {
			scrolled >= 25 ? header.classList.add('--black') : header.classList.remove('--black');
		} else if (headerBlack) {
			const logoPathsArray = Array.from(document.getElementsByClassName('path'));
			const whiteBurger = document.getElementById('white-burger');
			const blackBurger = document.getElementById('black-burger');
			const pathArr = Array.from(document.getElementsByClassName('button__svg_path'));
			const menuLinks = Array.from(document.getElementsByClassName('menu__item_link'));
			const circleButtons = Array.from(document.getElementsByClassName('nav-circle-button'));
			const logoutButton = document.getElementById('logout-btn');
			const selectedLink = Array.from(document.getElementsByClassName('--selected-link'))[0];

			const whiteLogo = document.getElementById('navbar-black__main-logo_white');
			const blackLogo = document.getElementById('navbar-black__main-logo_black');

			if (scrolled >= 25) {
				headerBlack.classList.add('--black');
				logoPathsArray.map(item => {
					item.setAttribute('fill', 'white');
				});

				// dumb but really needed check
				if (whiteLogo !== undefined && blackLogo !== undefined && whiteLogo !== null && blackLogo !== null) {
					whiteLogo.classList.add('--show');
					blackLogo.classList.add('--hide');
				}

				whiteBurger.setAttribute('style', 'display:block');
				blackBurger.setAttribute('style', 'display:none');
				logoutButton && logoutButton.classList.add('--white');
				logoutButton && logoutButton.classList.remove('--black');
				selectedLink && selectedLink.classList.add('--selected-link-white');
				pathArr.map(item => item.setAttribute('style', 'fill:white'));
				menuLinks.map(item => {
					item.setAttribute('style', 'color: white');
				});
				circleButtons.map(item => {
					item.classList.remove('--black');
				});
			} else {
				headerBlack.classList.remove('--black');
				logoPathsArray.map(item => {
					item.setAttribute('fill', 'black');
				});

				if (blackLogo !== undefined && blackLogo !== null) {
					blackLogo.classList.remove('--hide');
					whiteLogo.classList.remove('--show');
					whiteLogo.classList.add('--hide');
				}

				whiteBurger.setAttribute('style', 'display:none');
				blackBurger.setAttribute('style', 'display:block');
				logoutButton && logoutButton.classList.add('--black');
				logoutButton && logoutButton.classList.remove('--white');
				selectedLink && selectedLink.classList.remove('--selected-link-white');
				pathArr.map(item => item.setAttribute('style', 'fill:black'));
				menuLinks.map(item => {
					item.setAttribute('style', 'color: black');
				});
				circleButtons.map(item => {
					item.classList.add('--black');
				});
			}
		} else return false;
	};

	handleScroll();

	window.onscroll = function() {
		handleScroll();
	};

	//--------------------------------------------------------------------------

	const mobileNavbar = document.getElementById('mobile-navbar');
	const menuButton = document.getElementById('menu-button-mobile');
	const closeMobileMenu = document.getElementById('close-mobile-menu');

	menuButton &&
		menuButton.addEventListener('click', function() {
			mobileNavbar.classList.toggle('--active');
		});

	closeMobileMenu &&
		closeMobileMenu.addEventListener('click', function() {
			mobileNavbar.classList.toggle('--active');
		});
})();
